// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"a2e5abc0","238":"fa01f96e","251":"e1f9d0bb","373":"84ce0fb8","434":"251a51ad","457":"5167f9bd","667":"a124d421","750":"34c53c96","789":"90092329","966":"7246bfa2","988":"71356474"}[chunkId] + ".chunk.js";
};